export const LEAD_DETAIL_TABS = [
    { id: 'overview', label: 'Overview' },
    { id: 'person', label: 'Person' },
    { id: 'company', label: 'Company' },
    { id: 'opportunities', label: 'Opportunities' },
    { id: 'pains', label: 'Pains & Challenges' },
    { id: 'signals', label: 'Signals' },
    { id: 'keypeople', label: 'Network', hasAI: true },
    { id: 'profileintel', label: 'Profile Intel', hasAI: true },
    { id: 'outreach', label: 'Outreach', hasAI: true },
] as const;
